import { render } from "./Ladda.vue?vue&type=template&id=2f252d62"
import script from "./Ladda.vue?vue&type=script&lang=js"
export * from "./Ladda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__